module.exports = __webpack_public_path__ + "img/TFQS-box.e5c09892.svg";